import { render, staticRenderFns } from "./DetailCostWarning.vue?vue&type=template&id=ea288cde&"
import script from "./DetailCostWarning.vue?vue&type=script&lang=js&"
export * from "./DetailCostWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports